module.exports = __webpack_public_path__ + "img/_85C9122.bcc59b3d.jpeg";